import React, { useState, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonPage, IonHeader, IonContent } from '@ionic/react'
import { Input } from '@cps'
import { menuMobx, cartMobx, storeMobx } from 'restaurant'
import hotProductMobx from 'mobx/menu/hotProduct.mobx'
import { voiceServiceMobx } from '@mobxStore'
import { useHistoryNew, modalLayer, toastLayer } from '@utils'
import { useDebounce } from '@dt/fe-utils'
import { mpc } from '@dt/mmg-sdk'
import CashierController from '@ctrls/cashierController'
import productStyleController from '@ctrls/productStyleController'

import { ActivityModal } from '@pages/menu/modal'
import WaterfallItem from '@pages/menu/components/WaterfallItem'
import { WaterfallProductItem, WaterfallActivityItem } from './components'
import NoSearchImg from '@img/no_search.png'
import { RouteComponentProps } from 'react-router-dom'

import './index.scss'
interface IProps extends RouteComponentProps {

}

// 存储计算结果
const lineToResult = {}
const Search: React.FC<IProps> = props => {
  const history = useHistoryNew()
  const { type = '' } = props.match.params as { type?: string }
  const { productNoToCntMap } = cartMobx.cartResult
  const { searchList: resultList, isOpenSearchActivity, isVoiceSearchEnable } = voiceServiceMobx

  const isProduct = useMemo(() => {
    const res = !resultList.length || resultList.length && ['FixedCombo', 'OptionalCombo', 'product'].includes(resultList[0].type ? resultList[0].type : resultList[0].content_type)
    return res
  }, [resultList])

  const [productStyleMap, setProductStyleMap] = useState({} as {
    [no: string]: {
      left: number;
      top: number;
    };
  })

  useEffect(() => {
    hotProductMobx.init()
    window.addEventListener(window.onorientationchange ? 'orientationchange' : 'resize', () => {
      // calcWaterfall()
    }, false)

    return () => {
      menuMobx.setSearchKey('')
      voiceServiceMobx.setSearchList([])
    }
  }, [])

  const hashProduct = useMemo(() => {
    return resultList.map(p => p.no || p.contextId).join('')
  }, [resultList])
  const calcWaterfall = () => {
    const payload = productStyleController.waterfall(resultList, false, isProduct ? 'no' : 'contextId', 'search')
    if (payload) {
      const { styleMap, height } = payload
      lineToResult[hashProduct] = payload
      setProductStyleMap(styleMap)
      // setHeight(height)
    } else {
      setTimeout(() => {
        calcWaterfall()
      }, 300)
    }
  }
  useEffect(() => {
    if (resultList.length && hashProduct) {
      if (lineToResult[hashProduct]) {
        setProductStyleMap(lineToResult[hashProduct].styleMap)
        // setHeight(lineToResult[hashProduct].height)
      } else {
        setTimeout(() => {
          calcWaterfall()
        }, 50)
      }
    }
  }, [hashProduct])

  const handleSelectProduct = (result) => {
    if (isProduct) {
      CashierController.showProductDetail(result)
    } else {
      const { isDisable, disableReason } = result
      if (!isDisable) {
        modalLayer(ActivityModal, {
          data: result
        }).then((product: any) => {
          CashierController.handleProductToCart({
            type: 'add',
            product,
            isAddProduct: true
          })
        }).catch(() => {
        })
      } else {
        const errStr = i18n.t(`activity.${disableReason === 'time' ? 'activityNotStart' : 'onlyForMember'}`)
        toastLayer.info({
          content: errStr,
          duration: 1000
        })
      }
    }
  }

  const handleCancelSearch = () => {
    history.goBack()
  }

  const handleMicrophoneClick = () => {
    // push无法触发卸载方法
    history.replace('/menu', { tt: 'voice' })
  }

  const handleSearch = useDebounce(async (e) => {
    const res = await voiceServiceMobx.contentMatch(e.target.value)
    const { content: list, info } = res
    if (list.filter(item => item.content_type === 'call_activity').length) {
      if (isOpenSearchActivity) {
        const act = await mpc.refreshActivity()
        const availableActsMap = await voiceServiceMobx.getActsList(act)
        // setResultList(availableActsMap)
        voiceServiceMobx.setSearchList(availableActsMap)
        return
      }
      voiceServiceMobx.setSearchList([])
    } else {
      // setSearchType('product')
      const products = list.filter(item => item.content_type === 'product')
      const searchedProducts = voiceServiceMobx.getSearchedProducts(products)
      // setResultList(searchedProducts)
      voiceServiceMobx.setSearchList(searchedProducts)
    }
  }, 500)

  return (
    <IonPage className='search-page'>
      <IonHeader>
        <div className='search-input-wrapper'>
          <span onClick={handleCancelSearch} className='btn-back'>
            <i className='iconfont icon-BACK-12x'></i>
          </span>
          <Input
            icon='iconfont icon-search'
            placeholder={i18n.t('menu.search_product')}
            value={menuMobx.searchKey || ''}
            onChange={(e) => {
              menuMobx.setSearchKey(e.target.value)
              if (![undefined, null, ''].includes(String(e.target.value).trim())) {
                handleSearch(e)
              } else {
                voiceServiceMobx.setSearchList([])
              }
            }}
            autoFocus
          />
          {
            isVoiceSearchEnable ? (
              <span className='btn-microphone' onClick={handleMicrophoneClick}>
                <i className='iconfont icon-vioce_microphone'></i>
              </span>
            ) : <></>
          }
        </div>
      </IonHeader>
      <IonContent className='search-content'>
        {!!(!menuMobx.searchKey && hotProductMobx.HotViewProduct.length) && (
          <div className='hot-product-wrapper'>
            <h5>{i18n.t('menu.hot_product')}</h5>
            {hotProductMobx.HotViewProduct.map((product) => {
              return (
                <div
                  className='simple-product'
                  onClick={() => handleSelectProduct(product)}
                  key={product.no}
                >
                  {product.name}
                </div>
              )
            })}
          </div>
        )}
        <div className='search-product-split'></div>
        {menuMobx.searchKey && (
          <div className='search-product-list waterfall-template search-waterfall-template'>
            {
              resultList.length ? (
                resultList.map((result) => {
                  const id = isProduct ? result.no : result.contextId
                  return (
                    <WaterfallItem
                      key={id}
                      lazy={false}
                      style={productStyleMap[id]}
                      id={'searchproduct' + id}
                      onClick={() => handleSelectProduct(result)}
                    >
                      {
                        isProduct ? (
                          <WaterfallProductItem
                            product={result}
                            count={productNoToCntMap?.[id] || 0}
                          />
                        ) : (
                          <WaterfallActivityItem
                            data={result}
                          />
                        )
                      }
                    </WaterfallItem>
                  )
                })
              ) : (
                <div className='empty-info'>
                  <img src={NoSearchImg} alt='' className='empty-info-pic' />
                  <p>{i18n.t('menu.no_search_product1')}</p>
                </div>
              )
            }
          </div>
        )}
      </IonContent>
    </IonPage>
  )
}

export default observer(Search)
